/* eslint-disable max-len */
import { ContentService } from '@blk/cwp-ng-framework';
import * as get from 'lodash/get';
import * as sortBy from 'lodash/sortBy';

import { InsightsTransform } from './insights-transform';

export class TotalActiveRiskInsightsTransform extends InsightsTransform {

	public overviewParagraph: string;
	public conclusionParagraph: string;
	private overviewParagraphDCR: string;
	private conclusionParagraphDCR: string;

	constructor(public contentSvc: ContentService) {
		super(contentSvc);
	}

	protected setupContent(): void {
		this.overviewParagraphDCR = this.contentSvc.get(
			'ACTIVE_RISK_INSIGHTS_OVERVIEW_DCR',
			'<p>The portfolio has an active risk of {0} which implies <b>{1} probability that the portfolio&#39;s performance could differ materially from its benchmark</b>. Active risk is a double-edged sword which can lead to outperformance or underperformance, depending on how the active tilts are rewarded. <b>The two largest active tilts</b> in the portfolio are <b>{2}</b> and <b>{3}</b>.</p>'
		);
		this.conclusionParagraphDCR = this.contentSvc.get(
			'ACTIVE_RISK_INSIGHTS_CONCLUSION_DCR',
			'<p>The right level of active risk depends on your objectives.</p><p>The portfolio has {0} active risk and could be expected to <b>{1}</b>.</p><p><b>Is this level and source of active risk in line with your intentions?</b></p>'
		);
	}

	protected getEvaluatedOverview(selectedPortfolioIndex: number): string {
		const activeRiskCell = get(this.insightsTab, 'tableData[0].cells[' + selectedPortfolioIndex + '][0]', {});

		if (activeRiskCell.rawValue || activeRiskCell.rawValue === 0) {
			const factorData = [];
			for (let idx = 0; idx < get(this.factorsTab, 'tableData[0].headersX.length'); idx++) {
				if (!get(this.factorsTab, 'tableData[0].headersX[' + idx + '].attribute.ignoreInChart')) {
					factorData.push({
						name: get(this.factorsTab, 'tableData[0].headersX[' + idx + '].formattedValue'),
						value: get(this.factorsTab, 'tableData[0].cells[' + selectedPortfolioIndex + '][' + idx + '].rawValue')
					});
				}
			}
			const factorDataSorted = sortBy(factorData, [data => data.value]);

			return this.overviewParagraphDCR
				.replace('{0}', activeRiskCell.formattedValue)
				.replace('{1}', this.getRisk(+activeRiskCell.rawValue))
				.replace('{2}', factorDataSorted && factorDataSorted.length > 0 && factorDataSorted[factorData.length - 1] ? factorDataSorted[factorData.length - 1].name : 'n/a')
				.replace('{3}', factorDataSorted && factorDataSorted.length > 1 && factorDataSorted[factorData.length - 2] ? factorDataSorted[factorData.length - 2].name : 'n/a');
		} else {
			return null;
		}
	}
	protected getEvaluatedConclusion(selectedPortfolioIndex: number): string {
		const activeRisk = get(this.insightsTab, 'tableData[0].cells[' + selectedPortfolioIndex + '][0].rawValue');
		return activeRisk || activeRisk === 0
			? this.conclusionParagraphDCR.replace('{0}', this.getRisk(+activeRisk)).replace('{1}', this.getBenchmarkDescription(+activeRisk))
			: null;
	}

	private getBenchmarkDescription(value: number): string {
		if (value > this.CEIL_VALUE) {
			return this.translate('RISK_INSIGHTS_BENCHMARK_LEVEL_1_DESC', 'vary from its benchmark significantly', this.contentSvc);
		} else if (value < this.FLOOR_VALUE) {
			return this.translate('RISK_INSIGHTS_BENCHMARK_LEVEL_3_DESC', 'track the benchmark fairly closely', this.contentSvc);
		} else {
			return this.translate('RISK_INSIGHTS_BENCHMARK_LEVEL_2_DESC', 'vary from its benchmark moderately', this.contentSvc);
		}
	}
}
